export default {
  TO: {
    HELP: 'Participants can see this comment on this order',
    SELECT: 'Leave empty for internal note, or add recipient(s) to send a comment'
  },
  TEXT: {
    PLACEHOLDER: 'Enter a comment or add an internal note'
  }
}
